import React from "react";

const Lock = ({ style }) => (
  <svg
    style={style}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0001 30.3625C22.5755 30.3625 23.8526 29.0854 23.8526 27.51C23.8526 25.9346 22.5755 24.6575 21.0001 24.6575C19.4247 24.6575 18.1476 25.9346 18.1476 27.51C18.1476 29.0854 19.4247 30.3625 21.0001 30.3625Z"
      fill="url(#paint0_linear_672_11599)"
    />
    <path
      d="M29.1375 16.52H12.8625C5.6875 16.52 3.5 18.7075 3.5 25.8825V29.1375C3.5 36.3125 5.6875 38.5 12.8625 38.5H29.1375C36.3125 38.5 38.5 36.3125 38.5 29.1375V25.8825C38.5 18.7075 36.3125 16.52 29.1375 16.52ZM21 32.795C18.0775 32.795 15.715 30.415 15.715 27.51C15.715 24.605 18.0775 22.225 21 22.225C23.9225 22.225 26.285 24.605 26.285 27.51C26.285 30.415 23.9225 32.795 21 32.795Z"
      fill="url(#paint1_linear_672_11599)"
    />
    <path
      d="M12.4601 16.5375V14.49C12.4601 9.3625 13.9126 5.95 21.0001 5.95C28.0876 5.95 29.5401 9.3625 29.5401 14.49V16.5375C30.4326 16.555 31.2376 16.59 31.9901 16.695V14.49C31.9901 9.765 30.8526 3.5 21.0001 3.5C11.1476 3.5 10.0101 9.765 10.0101 14.49V16.6775C10.7451 16.59 11.5676 16.5375 12.4601 16.5375Z"
      fill="url(#paint2_linear_672_11599)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_672_11599"
        x1="21.0001"
        y1="24.6575"
        x2="21.0001"
        y2="30.3625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFD1BB" />
        <stop offset="1" stopColor="#7E858F" stopOpacity="0.92" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_672_11599"
        x1="21"
        y1="16.52"
        x2="21"
        y2="38.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#40E5A0" />
        <stop offset="1" stopColor="#269C79" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_672_11599"
        x1="21.0001"
        y1="3.5"
        x2="21.0001"
        y2="16.695"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFD1BB" />
        <stop offset="1" stopColor="#7E858F" stopOpacity="0.92" />
      </linearGradient>
    </defs>
  </svg>
);

export default Lock;
